import { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ProductGrid.css";

// Import images
import product20 from '../products/worker.jpg';
import product21 from '../products/worker4.jpg';
import product22 from '../products/globe4.jpg';
import compliance from '../products/compliance.png';
import consultancy from '../products/consultancy.png';
import training from '../products/training.jpg';
import isoImage from '../products/iso.jpg';

const ProductGrid = () => {
    const navigate = useNavigate();

    const products = [
        { id: 'iso-14001', title: "ISO 14001 Audit", image: isoImage, desc: "Validating your commitment to the planet. Ensuring your Environmental Management System (EMS) meets international standards.", route: "/Audit/ISO14K1" },
        { id: 1, title: "Professional Audit", image: product20, desc: "Comprehensive risk assessment & safety compliance audits.", route: "/Audit/SafetyAssessment" },
        { id: 2, title: "Workplace Solutions", image: product21, desc: "Tailored safety strategies for hazard-free environments.", route: "/Audit/OHSMS" },
        { id: 3, title: "Environmental Care", image: product22, desc: "Sustainable practices to protect people and the planet.", route: "/training/general/environmental" },
        { id: 4, title: "Compliance Services", image: compliance || product20, desc: "Ensuring your business meets all regulatory standards.", route: "/Compliance/SafetyLegalCompliance" },
        { id: 5, title: "Consultancy", image: consultancy || product21, desc: "Expert guidance on EHS policies and implementation.", route: "/Consultancy/SafetyLegislation" },
        { id: 6, title: "Training Programs", image: training || product22, desc: "Empowering your workforce with certified safety skills.", route: "/training" },
    ];

    const handleCardClick = (route) => {
        navigate(route);
    };

    const scrollRef = useRef(null);
    const [isPaused, setIsPaused] = useState(false);

    useEffect(() => {
        const scrollContainer = scrollRef.current;
        if (!scrollContainer) return;


        const speed = 1; // Pixels per frame
        let animationId;

        const step = () => {
            // Disable auto-scroll logic on mobile devices (< 768px) to prevent fighting with native swipe/snap
            if (!isPaused && window.innerWidth >= 768) {
                // If we've scrolled to the end (approx), reset to 0 for infinite loop illusion
                // A better approach for seamless loop is duplicating content, but for this "auto+manual" 
                // hybrid, a simple scroll that resets or bounces is often expected. 
                // Let's do a continuous scroll that bounces back or seamless if we duplicate.
                // For simplicity and manual scroll usability, simple auto-scroll that pauses is best.

                scrollContainer.scrollLeft += speed;

                // Check if we reached the end
                if (scrollContainer.scrollLeft + scrollContainer.clientWidth >= scrollContainer.scrollWidth - 1) {
                    scrollContainer.scrollLeft = 0; // Snap back to start for now
                }
            }
            animationId = requestAnimationFrame(step);
        };

        animationId = requestAnimationFrame(step);

        return () => cancelAnimationFrame(animationId);
    }, [isPaused]);

    return (
        <div className="product-scroll-wrapper">
            <div
                className="product-scroll-container"
                ref={scrollRef}
                onMouseEnter={() => setIsPaused(true)}
                onMouseLeave={() => setIsPaused(false)}
                onTouchStart={() => setIsPaused(true)}
                onTouchEnd={() => setIsPaused(false)}
            >
                {/* Duplicate products to help with smoother scrolling illusion if needed, 
                  but for manual scroll compatibility, a single list is clearer. 
                  Users can scroll manually, and when they let go (leave), auto scroll resumes. */}
                {products.map((product) => (
                    <div
                        key={product.id}
                        className="product-scroll-card"
                        onClick={() => handleCardClick(product.route)}
                        style={{ cursor: 'pointer' }}
                    >
                        <div className="card-image-wrapper">
                            <img
                                src={product.image}
                                alt={product.title}
                                className="product-scroll-image"
                            />
                            <div className="card-overlay">
                                <span className="overlay-btn">Learn More</span>
                            </div>
                        </div>
                        <div className="card-info">
                            <h3 className="card-heading">{product.title}</h3>
                            <p className="card-desc">{product.desc}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
export default ProductGrid;